import { addWidgetStyles } from '@/utilities/addWidgetStyles'
import { initGAListener } from '@/utilities/initGAListener'
import { initGTMListener } from '@/utilities/initGTMListener'
import { initIframeInjection } from '@/utilities/initIframeInjection'
import { setAndCheckUniqueIdentifier } from '@/utilities/setAndCheckUniqueIdentifier'

;(function () {
  const scriptAlreadyPresent = setAndCheckUniqueIdentifier()

  // Page-level side effects must only run once, no matter how many
  // bootstrapper copies the page loads.
  if (!scriptAlreadyPresent) {
    addWidgetStyles()

    // Initialize the GA listener
    initGAListener()

    initGTMListener()
  }

  // Every copy scans for snippets (injection is idempotent per snippet).
  // Upgraded V1 widgets insert their snippet plus a fresh bootstrapper copy
  // after page load, one per widget, whenever each widget's response lands —
  // so no single copy's scan can see them all.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initIframeInjection)
  } else {
    initIframeInjection()
  }
})()
